import { render, staticRenderFns } from "./WidgetReviewsBestGalleryMobile.vue?vue&type=template&id=94340df6"
import script from "./WidgetReviewsBestGalleryMobile.vue?vue&type=script&lang=js"
export * from "./WidgetReviewsBestGalleryMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports